'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.format = exports.wrapAttribute = exports.Money = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _specialFormats = require('./special-formats');

Object.keys(_specialFormats).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _specialFormats[key];
    }
  });
});

var _accounting = require('accounting');

var _accounting2 = _interopRequireDefault(_accounting);

var _lodash = require('lodash');

var _specialFormats2 = _interopRequireDefault(_specialFormats);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Money = exports.Money = function () {
  function Money(cents, currency) {
    _classCallCheck(this, Money);

    this.amountCents = cents;
    this.currencyCode = currency;
  }

  _createClass(Money, [{
    key: 'convert',
    value: function convert() {
      var rate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      return money(this.amountCents * rate, this.currencyCode);
    }
  }, {
    key: 'isZero',
    value: function isZero() {
      return this.amountCents === 0;
    }
  }, {
    key: 'isPositive',
    value: function isPositive() {
      return this.amountCents > 0;
    }
  }, {
    key: 'isGreaterThan',
    value: function isGreaterThan(other) {
      this._checkCurrency(other);

      return this.amountCents > other.amountCents;
    }
  }, {
    key: 'isGreaterThanOrEqual',
    value: function isGreaterThanOrEqual(other) {
      this._checkCurrency(other);

      return this.amountCents >= other.amountCents;
    }
  }, {
    key: 'isLessThan',
    value: function isLessThan(other) {
      this._checkCurrency(other);

      return this.amountCents < other.amountCents;
    }
  }, {
    key: 'isLessThanOrEqual',
    value: function isLessThanOrEqual(other) {
      this._checkCurrency(other);

      return this.amountCents <= other.amountCents;
    }
  }, {
    key: 'hasSameCurrency',
    value: function hasSameCurrency(other) {
      return other.currencyCode === this.currencyCode;
    }
  }, {
    key: 'isEqual',
    value: function isEqual(other) {
      if (!this.hasSameCurrency(other)) return false;

      return this.amountCents === other.amountCents;
    }
  }, {
    key: '_checkCurrency',
    value: function _checkCurrency(other) {
      if (!this.hasSameCurrency(other)) throw new Error('Different currency comparison attempted');
    }
  }], [{
    key: 'isMoney',
    value: function isMoney(item) {
      return item instanceof Money;
    }
  }, {
    key: 'validateMoneys',
    value: function validateMoneys(ary) {
      var _this = this;

      var allCorrect = ary.reduce(function (res, cur) {
        return res && _this.isMoney(cur);
      }, true);
      if (!allCorrect) throw new Error('Not all items are instances of Money');
    }
  }, {
    key: 'validateSameCurrency',
    value: function validateSameCurrency(ary) {
      var currencies = ary.map(function (money) {
        return money.currencyCode;
      });
      if ((0, _lodash.uniq)(currencies).length > 1) throw new Error('Different currencies provided');
    }
  }, {
    key: 'validateCurrency',
    value: function validateCurrency(currency) {
      if (!(0, _lodash.includes)(this.supportedCurrencies, currency)) {
        throw new Error('Currency ' + currency + ' is not supported');
      }
    }
  }, {
    key: 'sum',
    value: function sum(ary) {
      var defaultCurrency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _specialFormats.USD;

      this._validate(ary);
      var amountCents = ary.reduce(function (acum, cur) {
        return acum + cur.amountCents;
      }, 0);
      return money(amountCents, (0, _lodash.get)((0, _lodash.first)(ary), 'currencyCode', defaultCurrency));
    }
  }, {
    key: 'subtract',
    value: function subtract(amountA, amountB) {
      this._validate([amountA, amountB]);
      return money(amountA.amountCents - amountB.amountCents, amountA.currencyCode);
    }
  }, {
    key: 'max',
    value: function max(ary) {
      var compacted = ary.filter(function (i) {
        return i;
      });
      this._validate(compacted);
      return (0, _lodash.maxBy)(compacted, 'amountCents');
    }
  }, {
    key: 'min',
    value: function min(ary) {
      var compacted = ary.filter(function (i) {
        return i;
      });
      this._validate(compacted);
      return (0, _lodash.minBy)(compacted, 'amountCents');
    }
  }, {
    key: 'zero',
    value: function zero(currency) {
      this.validateCurrency(currency);
      return money(0, currency);
    }
  }, {
    key: '_validate',
    value: function _validate(ary) {
      this.validateMoneys(ary);
      this.validateSameCurrency(ary);
    }
  }, {
    key: 'supportedCurrencies',
    get: function get() {
      return _specialFormats.SUPPORTED_CURRENCIES;
    }
  }]);

  return Money;
}();

var money = function money(input) {
  var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _specialFormats.USD;

  var cents = input;
  var _currency = currency;

  if (input === null || input === undefined) return input;

  if (input instanceof Money) return input;

  if ((typeof input === 'undefined' ? 'undefined' : _typeof(input)) === 'object' && input.hasOwnProperty('amountCents')) {
    cents = input.amountCents;
    if (input.hasOwnProperty('currencyCode')) {
      _currency = input.currencyCode.toUpperCase();
    }
  }

  if (typeof input === 'string') {
    cents = parseInt(input.replace(/[^\d]/g, ''), 10);
    if (isNaN(cents)) return null;
  }

  return new Money(cents, _currency);
};

var wrapAttribute = exports.wrapAttribute = function wrapAttribute(attribute) {
  return function (item) {
    return _extends({}, item, _defineProperty({}, attribute, money(item[attribute])));
  };
};

var format = function format(money) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!money) return '';

  var _options$format = options.format,
      format = _options$format === undefined ? {} : _options$format,
      otherOptions = _objectWithoutProperties(options, ['format']);

  var specialFormat = _specialFormats2.default[money.currencyCode.toLowerCase()] || {};
  var formatOptions = _extends({
    symbol: '$',
    thousand: ',',
    decimal: '.',
    precision: 2,
    format: _extends({
      pos: '%s%v',
      neg: '%s(%v)',
      zero: '%s00.00'
    }, format)
  }, specialFormat, otherOptions);

  return _accounting2.default.formatMoney(money.amountCents / 100, formatOptions);
};

exports.format = format;
exports.default = money;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@paybygroup/baelish/dist/index.js
// module id = 234
// module chunks = 1 2